const taxBases = (["turnover", "profit"] as const).map((e) => e);
export type TaxBases = (typeof taxBases)[0];

export class TaxBase {
  constructor({ name }: { name: TaxBases }) {
    this.name = name;
  }

  name: TaxBases;

  static def: TaxBase = new TaxBase({ name: "profit" });

  static fromString(str: string): TaxBase {
    const lowerStr = str.replace(/[_-]/g, "").toLowerCase();
    const name = taxBases.find((e) => e.toLowerCase() === lowerStr);
    if (name) {
      return new TaxBase({ name });
    }
    throw new Error("Invalid type of the tax base.");
  }

  static isValidString(str?: string): boolean {
    const lowerStr = str?.replace(/[_-]/g, "")?.toLowerCase();
    const name = taxBases.find((e) => e.toLowerCase() === lowerStr);
    return !!name;
  }

  toString(): string {
    return this.name;
  }
}
